import it from './it.json';

export default { it };
